// removed by extract-text-webpack-plugin
module.exports = {"view":"view__3WQKc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/styles.scss
// module id = 2248
// module chunks = 1